import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Styled = styled.div`
  width: 48px;
  fill: ${props => (props.bright ? props.theme.colorBright : props.theme.colorText)};

  svg {
    width: 100%;
    height: auto;
  }
`;

const Logo = ({ className, bright }) => (
  <Styled className={className} bright={bright}>
    <svg width="48" height="37" viewBox="0 0 48 37" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero">
        <path d="M24 18.5L0 0v37zM24 18.5L48 0v37z" />
      </g>
    </svg>
  </Styled>
);

Logo.propTypes = {
  className: PropTypes.string,
  bright: PropTypes.bool,
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js